import { render, staticRenderFns } from "./ManageServiceContent.vue?vue&type=template&id=e24d468e"
import script from "./ManageServiceContent.vue?vue&type=script&lang=js"
export * from "./ManageServiceContent.vue?vue&type=script&lang=js"
import style0 from "./ManageServiceContent.vue?vue&type=style&index=0&id=e24d468e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports